<template>
    <div id="firebaseui-spa">
        <div id="firebaseui-container"></div>
    </div>
</template>

<script>
    import firebase from 'firebase';
    import firebaseui from 'firebaseui'
    import {config} from '@/firebase/init'

    require('../../../node_modules/firebaseui/dist/firebaseui.css');

    export default {
        name: "Login",
        mounted() {
            var uiConfig = {
                signInSuccessUrl: '/secured/employee',
                signInOptions: [
                    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                    firebase.auth.EmailAuthProvider.PROVIDER_ID
                ]
            };
            var ui = new firebaseui.auth.AuthUI(firebase.auth());
            ui.start('#firebaseui-container', uiConfig);
        }
    }
</script>

<style scoped>
    #firebaseui-container {
        padding: 50px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/Login.vue